import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    loading: false,
    response: null,
    error: null,
    taskList: null,
    tickettask: null,
    singleTask: null,
    employeList: null,
    notesList: null,
    startTime: null,
    endTime: null,
    getTime: null
}

export const GetTaskList = createAsyncThunk(
    "GetTaskList",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/crm/tasks/list-all?page=${body.page}&search=${body.search}&fStartDate=${body.fStartDate}&fEndDate=${body.fEndDate}&fStatus=${body.fStatus}&member=${body.member}&fStatus=${body.fStatus}&member=${body.member}&fSortBy=${body.fSortBy}&sort_column=${body.sort_column}`);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response)
        }



    })

export const getAllEmployeeList = createAsyncThunk(
    "getAllEmployeeList",
    async (body, { rejectWithValue }) => {
        try {


            const response = await instance.get(`/crm/employees/get-employee-list`);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response)
        }
    })

export const GetTask = createAsyncThunk("GetTask", async (id, { rejectWithValue }) => {
    try {
        const response = await instance.get(`/crm/tasks/get-task?id=${id}`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error?.response);
    }
})

export const fetchAllTicketTask = createAsyncThunk("fetchAllTicketTask", async (_, { rejectWithValue }) => {
    try {
        const response = await instance.get("/crm/tasks/list-ticket-task");
        return response?.data;
    } catch (error) {
        return rejectWithValue(error?.response || { message: "Something went wrong" });
    }
})

export const CreateTask = createAsyncThunk(
    "CreateTask",
    async (body, { rejectWithValue }) => {
        const formData = new FormData();
        formData.append("task_assigned_to", body.task_assigned_to);
        formData.append("task_description", body.task_description);
        formData.append("task_end_at", body.task_end_at);
        formData.append("task_started_at", body.task_started_at);
        formData.append("task_title", body.task_title);
        formData.append("task_status", body.task_status);
        formData.append("task_priority", body.task_priority);
        if (body.task_attached_file) {
            if (Array.isArray(body.task_attached_file)) {
                // Multiple files
                body.task_attached_file.forEach((file) => {
                    formData.append("task_attached_file[]", file);
                });
            } else {
                // Single file
                formData.append("task_attached_file", body.task_attached_file);
            }
        }
        try {
            const response = await instance.post("/crm/tasks/create-task", formData);
            return response?.data
        } catch (error) {
            return rejectWithValue(error.response)
        }
    }
)

// {Comment task}

export const CommentOnTask = createAsyncThunk(
    "CommentOnTask",
    async (body, { rejectWithValue }) => {
        // debugger
        const formData = new FormData();
        // formData.append("task_id",  task.task_id);
        formData.append("tc_comment", body.tc_comment);
        formData.append("tc_created_by", body.name);
        formData.append("tc_sender_id", body.e_id);

        try {
            const response = await instance.post(`/crm/tasks/add_task_comment?id=${body.task_id}`, formData);
            return response?.data
        } catch (error) {
            return rejectWithValue(error.response)
        }
    }
)


export const CommentOnTicketTask = createAsyncThunk(
    "CommentOnTicketTask",
    async (body, { rejectWithValue }) => {

        const formData = new FormData();
        formData.append("ticket_tsk_comment", body?.ticket_tsk_comment);
        formData.append("ticket_tsk_id", body?.ticket_tsk_id);

        try {

            const response = await instance.post("/crm/tasks/comment-ticket-task", formData);
            return response?.data
        } catch (error) {
            return rejectWithValue(error.response)
        }
    }
)

//create-ticket-task-------
export const assignTicketTask = createAsyncThunk(
    "assignTicketTask",
    async (body, { rejectWithValue }) => {
        // debugger;


        const formData = new FormData();
        // formData.append("tsk_subject", body.t_subject);
        // formData.append("tsk_description", body.t_description);
        // formData.append("tsk_project_name", body.t_project_name);
        // formData.append("tsk_project_type", body.t_project_type);
        // formData.append("tsk_priority", body.t_priority);
        formData.append("tsk_assigned_to", body.tsk_assigned_to);
        formData.append("tsk_subject", body.tsk_subject);
        try {
            const response = await instance.post(`/crm/tasks/update-ticket-task?id=${body?.tsk_id}`, formData);
            return response?.data
        } catch (error) {
            return rejectWithValue(error.response)
        }
    }
)
export const CreateTicketTask = createAsyncThunk(
    "CreateTicketTask",
    async (body, { rejectWithValue }) => {


        // const formData = new FormData();
        // formData.append("tsk_subject", body.t_subject);
        // formData.append("tsk_description", body.t_description);
        // formData.append("tsk_project_name", body.t_project_name);
        // formData.append("tsk_project_type", body.t_project_type);
        // formData.append("tsk_priority", body.t_priority);
        // formData.append("tsk_assigned_to", body.t_assigned_to);
        // formData.append("tsk_assigned_by", body.t_assigned_by);
        // formData.append("tsk_doc", body.tsk_doc);
        try {
            const response = await instance.post("/crm/tasks/create-ticket-task", body);
            return response?.data
        } catch (error) {
            return rejectWithValue(error.response)
        }
    }
)

export const updateStatusTicketTask = createAsyncThunk("updateStatusTicketTask",
    async (body, { rejectWithValue }) => {
        // debugger;
        const formData = new FormData();
        formData.append("tsk_id", body.tsk_id);
        formData.append("tsk_status", body.tsk_status);


        try {

            const response = await instance.post(`/crm/tasks/update-ticket-task-status?tsk_id=${body?.tsk_id}`, formData);
            return response?.data
        } catch (error) {
            // debugger;

            return rejectWithValue(error?.response)
        }

    })
// export const UpdateTask = createAsyncThunk("UpdateTask",
//     async (body, { rejectWithValue }) => {
//         try {

//             const response = await instance.post(`/crm/tasks/update-task?id=${body?.id}`, body);
//             return response?.data
//         } catch (error) {
//             return rejectWithValue(error?.response)
//         }

//     })
export const UpdateTask = createAsyncThunk(
    "UpdateTask",
    async (body, { rejectWithValue }) => {
        try {
            const formData = new FormData();

            formData.append("task_title", body.task_title || "");
            formData.append("task_description", body.task_description || "");
            formData.append("task_assigned_to", body.task_assigned_to || "");
            formData.append("task_assigned_by", body.task_assigned_by || "");
            formData.append("task_started_at", body.task_started_at || "");
            formData.append("task_end_at", body.task_end_at || "");
            formData.append("task_status", body.task_status || "0");
            formData.append("task_priority", body.task_priority || "");

            //  FILE HANDLE (single + multiple)
            if (body.task_attached_file) {
                if (Array.isArray(body.task_attached_file)) {
                    body.task_attached_file.forEach((file) => {
                        formData.append("task_attached_file[]", file);
                    });
                } else {
                    formData.append("task_attached_file", body.task_attached_file);
                }
            }

            const response = await instance.post(
                `/crm/tasks/update-task?id=${body.id}`,
                formData
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);


export const InvitMemberInTask = createAsyncThunk(
    "InvitMemberInTask",
    async (body) => {
        try {
            const response = await instance.post(`/crm/tasks/intask-invited-member?id=${body.id}&inviteId=${body.inviteId}`)
            return response.data;
        } catch (error) {
            return error?.response
        }
    }
)



export const UpdateStatus = createAsyncThunk(
    "UpdateStatus",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/crm/tasks/update-status?id=${body?.id}&status=${body?.status}&priority=${body?.priority} `);
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response)
        }

    })

// Add note description
export const AddTaskDescription = createAsyncThunk("AddTaskDescription", async (body) => {
    try {
        const response = await instance.post(`/crm/tasks/add-task-note?tn_task_id=${body?.tn_task_id}&tn_task_note=${body?.tn_task_note}&tn_task_action_type=${body?.tn_task_action_type}`);
        return response?.data;
    } catch (error) {
        return error;
    }
})

export const getNotesList = createAsyncThunk("getNotesList", async (id) => {
    try {
        const response = await instance.get(`/crm/tasks/task-note-list?task_id=${id}`);
        return response?.data;
    } catch (error) {
        return error;
    }
});

// {Add Comment}
export const AddCommentTask = createAsyncThunk("AddCommentTask", async (body) => {
    try {

        const response = await instance.post(`/crm/tasks/add_task_comment?id=${body?.id}`, body);
        return response?.data;
    } catch (error) {
        return error;
    }
})
// {Update Comment}
export const updateCommentTask = createAsyncThunk("updateCommentTask", async (body) => {
    try {

        const response = await instance.post("/crm/tasks/update-comment", body);
        return response?.data;
    } catch (error) {
        return error;
    }
})

// {delete comment}
export const removeComment = createAsyncThunk(
    "removeComment",
    async (tc_id) => {
        try {
            const response = await instance.delete(`/crm/tasks/delete-comment/${tc_id}`);
            return response.data
        } catch (error) {

        }
    }
)

// {start timer and stop timer}

export const startTaskTimer = createAsyncThunk(
    'startTaskTimer',
    async (id) => {

        try {
            const response = await instance.get(`/crm/tasks/start-task-timer?task_id=${id}`);
            return response?.data
        }
        catch (error) {
            return error
        }
    }
)

export const stopTaskTimer = createAsyncThunk(
    'stopTaskTimer',
    async (id) => {

        try {
            const response = await instance.get(`/crm/tasks/stop-task-timer?task_id=${id}`);
            return response?.data
        }
        catch (error) {
            return error
        }
    }
)
export const getTaskTime = createAsyncThunk(
    'getTaskTime',
    async (id) => {

        try {
            const response = await instance.get(`/crm/tasks/get-task-time-details?task_id=${id}`);
            return response?.data
        }
        catch (error) {
            return error
        }
    }
)



export const TaskSlice = createSlice({
    name: "TaskSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(GetTaskList.pending, (state) => {
            state.loading = true;
            state.response = null;
            state.singleTask = null;
        });
        builder.addCase(GetTaskList.fulfilled, (state, action) => {


            state.loading = false;
            state.taskList = action.payload;
        });
        builder.addCase(GetTaskList.rejected, (state, action) => {
            state.loading = false;
            state.status = action.status?.data?.status;
            state.error = action.payload?.data;
        });

        builder.addCase(GetTask.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(GetTask.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.singleTask = action.payload;
        });
        builder.addCase(GetTask.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(CreateTask.pending, (state) => {
            state.loading = true;
            state.response = null;
        });
        builder.addCase(CreateTask.fulfilled, (state, action) => {

            state.loading = false;
            state.error = null;
            state.response = action.payload;
        });
        builder.addCase(CreateTask.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.data;
        })

        builder.addCase(AddCommentTask.pending, (state) => {
            state.loading = true;
            state.response = null;
        });
        builder.addCase(AddCommentTask.fulfilled, (state, action) => {

            state.loading = false;
            state.error = null;
            state.response = action.payload;
        });
        builder.addCase(AddCommentTask.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.data;
        })


        builder.addCase(updateCommentTask.pending, (state) => {
            state.loading = true;
            state.response = null;
        });
        builder.addCase(updateCommentTask.fulfilled, (state, action) => {

            state.loading = false;
            state.error = null;
            state.response = action.payload;
        });
        builder.addCase(updateCommentTask.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.data;
        })


        builder.addCase(removeComment.pending, (state) => {
            state.loading = true;
            state.response = null;
        });
        builder.addCase(removeComment.fulfilled, (state, action) => {

            state.loading = false;
            state.error = null;
            state.response = action.payload;
        });
        builder.addCase(removeComment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.data;
        })


        builder.addCase(UpdateTask.pending, (state) => {
            state.loading = true;
            state.response = null;
        });
        builder.addCase(UpdateTask.fulfilled, (state, action) => {

            state.loading = false;
            state.response = action.payload;
        });
        builder.addCase(UpdateTask.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        })

        builder.addCase(UpdateStatus.pending, (state) => {
            state.loading = true;
            state.response = null;
        });
        builder.addCase(UpdateStatus.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });
        builder.addCase(UpdateStatus.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.data;
        })

        builder.addCase(CreateTicketTask.pending, (state) => {
            state.loading = true;
            state.response = null;
        });
        builder.addCase(CreateTicketTask.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.response = action.payload;
        });
        builder.addCase(CreateTicketTask.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.data;
        })

        builder.addCase(getAllEmployeeList.pending, (state) => {
            state.loading = true;
            state.response = null;
        });
        builder.addCase(getAllEmployeeList.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.employeList = action.payload;
        });
        builder.addCase(getAllEmployeeList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        })

        builder.addCase(AddTaskDescription.pending, (state) => {
            state.loading = true;
            state.response = null;
        });
        builder.addCase(AddTaskDescription.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.response = action.payload;
        });
        builder.addCase(AddTaskDescription.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.data;
        })
        builder.addCase(getNotesList.pending, (state) => {
            state.loading = true;
            state.response = null;
        });
        builder.addCase(getNotesList.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.notesList = action.payload;
        });
        builder.addCase(getNotesList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.data;
        })


        builder.addCase(startTaskTimer.pending, (state) => {
            state.loading = true;
            state.startTime = null;
        });
        builder.addCase(startTaskTimer.fulfilled, (state, action) => {

            state.loading = false;
            state.error = null;
            state.startTime = action.payload;
        });
        builder.addCase(startTaskTimer.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.startTime;
        })

        builder.addCase(stopTaskTimer.pending, (state) => {
            state.loading = true;
            state.endTime = null;
        });
        builder.addCase(stopTaskTimer.fulfilled, (state, action) => {

            state.loading = false;
            state.error = null;
            state.endTime = action.payload;
        });
        builder.addCase(stopTaskTimer.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.endTime;
        })

        builder.addCase(getTaskTime.pending, (state) => {
            state.loading = true;
            state.getTime = null;
        });
        builder.addCase(getTaskTime.fulfilled, (state, action) => {

            state.loading = false;
            state.error = null;
            state.getTime = action.payload;
        });
        builder.addCase(getTaskTime.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.getTime;
        })


        builder.addCase(CommentOnTask.pending, (state) => {
            state.loading = true;
            state.response = null;
        });
        builder.addCase(CommentOnTask.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.response = action.payload;
        });
        builder.addCase(CommentOnTask.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.data;
        })
    }

})

export default TaskSlice.reducer;